module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<button id="' +
((__t = (id)) == null ? '' : __t) +
'" class="btn ' +
((__t = (btnCss)) == null ? '' : __t) +
' ' +
((__t = (enableClass)) == null ? '' : __t) +
'" type="submit" title="' +
((__t = (title)) == null ? '' : __t) +
'">\n    <div class="' +
((__t = (displayClass)) == null ? '' : __t) +
'"></div>\n</button>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/Button/bootstrap4/templates/Button.ejs
// module id = 398
// module chunks = 0